<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccInptRpt1.vue
*@ 컴포넌트설명 : 당행이체 - 이체확인증
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup :opened.sync="openData" :use-footer="true" class="popup" @cancel="popupClose">
      <template #subtitle>
        <h2>{{ /*이체 확인증 (당행)*/ $t("MPAY-04-01-06-A1") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span
            class="divider-date"
          >{{ /*이체 일시*/ $t("MPAY-04-01-06-A2") }} : {{ $getGlobalDateFmt(detailInfo.tranYmd) }}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /*출금정보*/ $t("MPAY-04-01-06-A3") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌번호*/ $t("MPAY-04-01-06-A4") }}</dt>
          <dd class="right">{{ detailInfo.acno }}</dd>
          <dt>{{ /*송금인*/ $t("MPAY-04-01-06-A5") }}</dt>
          <dd class="right">{{detailInfo.rqstrFname}}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-04-01-06-A6") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.drwotzAmt) }}</span>
          </dd>
          <dt>{{ /*적용 환율*/ $t("MPAY-04-01-06-A7") }}</dt>
          <dd class="right">
            <span class="amount">{{ detailInfo.aplyExrt }}</span>
          </dd>
          <dt>{{ /*수수료*/ $t("MPAY-04-01-06-A8") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.cncycd }}</span>
            <span class="amount">{{ $num(detailInfo.feeAmt) }}</span>
          </dd>
          <dt>{{ /*송금 메모*/ $t("MINQ-02-02-03-13") }}</dt>
          <dd class="right">{{ detailInfo.sumryCtnt1 }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금정보*/ $t("MPAY-04-01-06-A10") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-04-01-06-A11") }}</dt>
          <dd class="right">{{ detailInfo.cupldAcno }}</dd>
          <dt>{{ /*입금 금액*/ $t("MPAY-04-01-06-A12") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.lnkgAcnCncycd }}</span>
            <span class="amount">{{ $num(detailInfo.mrvamt) }}</span>
          </dd>
          <dt>{{ /* 수취인 */ $t("MPAY-04-01-06-A13") }}</dt>
          <dd class="right">{{ detailInfo.draweFname }}</dd>
          <dt>{{ /*수취인 참조내용*/ $t("MPAY-04-01-06-A14") }}</dt>
          <dd class="right">{{ detailInfo.sumryCtnt2 }}</dd>
        </dl>
        <ul class="ulist ulist-type--bullet">
          <li>{{ /*위의 내용이 정상적으로 처리되었음을 확인합니다. */ $t("MPAY-04-01-06-A15") }}</li>
          <li>{{ /*이체확인증은 고객 편의를 위하여 제공되는 것으로 거래의 참고용으로만 사용될 수 있습니다.*/ $t("MPAY-04-01-06-A16") }}</li>
        </ul>
        <div class="bank-name">
          <template v-if="siteCode == $config.SITECODE_OGHCM">
            <template v-if="operGroupCd == 'VN1'">{{ $t(`${siteCode}_지점명칭`) }}</template>
            <template v-else>{{ $t(`oghni_지점명칭`) }}</template>
          </template>
          <template v-else>{{ $t(`${siteCode}_지점명칭`) }}</template>
        </div>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="popupClose()"
        >{{ /*확인*/ $t("MPAY-04-01-06-A18") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
